<page-grid
  [gridConfig]="adxInvoicesGrid"
  (gridEvent)="handleCreateInvoiceDialog()"
  (gridClickColumn)="handleIdClick($event)">
  <ng-template #actionItem let-item="item">
    @if (loggedInUserHasDirectorOrFinanceOrManagerRole()) {
      <button color="primary" mat-icon-button aria-label="Create Payments for Invoice"
        cdkFocusInitial matTooltip="Create Payments for Invoice"
        [disabled]="true"
        (click)="handleInvoicePayments(item)">
        <mat-icon fontIcon="payments" />
      </button>
    }
    <button color="primary" mat-icon-button aria-label="ADX Invoice History"
      cdkFocusInitial matTooltip="Invoice History"
      (click)="handleInvoiceHistoryClick(item?.id)">
      <mat-icon>history</mat-icon>
    </button>
  </ng-template>
</page-grid>
